import React from "react";
import { Button, Typography } from "antd";
import { CreditCardOutlined, SendOutlined } from "@ant-design/icons";
import { parseNumber } from "../../../services/currencyService.js";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{
 *   visible: boolean,
 *   amountUsd: number | null,
 *   amountIls: number | null,
 *   exchangeRate: number | null,
 *   submitting: boolean,
 *   onSubmit: () => void,
 *   submitLabel?: string,
 *   isNameChange?: boolean,
 *   onGoToPayment?: () => void,
 *   paymentButtonLabel?: string,
 *   paymentLinkBusy?: boolean,
 * }} props
 */
export default function OperationRequestStickyFooter({
  visible,
  amountUsd,
  amountIls,
  exchangeRate,
  submitting,
  onSubmit,
  submitLabel = "שלח פנייה לאופרציה",
  isNameChange = false,
  onGoToPayment,
  paymentButtonLabel = "מעבר לתשלום (יעד שריג)",
  paymentLinkBusy = false,
}) {
  if (!visible) return null;

  const meta = (
    <div className={styles.stickyMeta}>
      {amountUsd != null ? (
        <>
          <Text strong style={{ fontSize: 15 }}>
            {parseNumber(amountUsd)}$
            {amountIls != null ? ` ≈ ${parseNumber(amountIls)} ₪` : ""}
          </Text>
          {exchangeRate != null ? (
            <Text type="secondary">לפי שער {exchangeRate} ₪ לדולר</Text>
          ) : amountIls == null ? (
            <Text type="secondary">חסר שער להצגת סכום בשקלים</Text>
          ) : null}
          {isNameChange ? (
            <Text type="secondary" style={{ fontSize: 12, marginTop: 4 }}>
              יש לבצע תשלום מקישור יעד שריג שנפתח לפני שליחת הפנייה לאופרציה
            </Text>
          ) : null}
        </>
      ) : (
        <Text type="secondary">מוכנים לשלוח את הפנייה</Text>
      )}
    </div>
  );

  const actions = isNameChange && typeof onGoToPayment === "function" ? (
    <div className={styles.stickyDualActions}>
      <Button
        type="primary"
        size="large"
        className={styles.stickySubmit}
        icon={<CreditCardOutlined />}
        loading={paymentLinkBusy}
        disabled={submitting || paymentLinkBusy}
        onClick={onGoToPayment}
      >
        {paymentButtonLabel}
      </Button>
      <Button
        type="default"
        size="large"
        className={styles.stickySecondary}
        icon={<SendOutlined />}
        loading={submitting}
        disabled={submitting || paymentLinkBusy}
        onClick={onSubmit}
      >
        {submitLabel}
      </Button>
    </div>
  ) : (
    <Button
      type="primary"
      size="large"
      className={styles.stickySubmit}
      icon={<SendOutlined />}
      loading={submitting}
      disabled={submitting}
      onClick={onSubmit}
    >
      {submitLabel}
    </Button>
  );

  return (
    <div className={styles.stickyBar}>
      <div className={styles.stickyInner}>
        {meta}
        {actions}
      </div>
    </div>
  );
}
